var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c("invoice-body", {
        attrs: {
          loading: !_vm.loaded,
          invoice: _vm.invoice,
          invoiceid: _vm.invoiceid,
          contact: _vm.contact
        },
        on: {
          pay: function pay($event) {
            _vm.modal = true
          }
        }
      }),
      _vm.loaded
        ? _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "500px",
                eager: ""
              },
              on: {
                keydown: function keydown($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape"
                    ])
                  ) {
                    return null
                  }
                  return _vm.closeModal($event)
                },
                "click:outside": _vm.closeModal
              },
              model: {
                value: _vm.modal,
                callback: function callback($$v) {
                  _vm.modal = $$v
                },
                expression: "modal"
              }
            },
            [
              _vm.invoice.balance > 0
                ? _c("invoice-payment", {
                    attrs: {
                      invoice: _vm.invoice,
                      compact: ""
                    },
                    on: {
                      "payment-complete": _vm.getInvoice,
                      close: function close($event) {
                        _vm.modal = false
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm.payments.length
        ? _c("invoice-history", {
            attrs: {
              payments: _vm.payments
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }